module.exports = __webpack_public_path__ + "img/s6-dialog4.163b6141.png";